module.exports = __webpack_public_path__ + "media/course_hero/ch_white_logo-b2f803e4.svg";